import useAppToast from '@/hooks/useAppToast';
import { getRezeptSheetList } from '@/services/admin/rezeptSheetService';
import type { RezeptSheetListQuery } from '@/types/admin-rezept-sheet';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Fetches paginated rezept sheets list for admin.
 * Shows toast on fetch error.
 */
export const useAdminRezeptSheetList = (query: RezeptSheetListQuery) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['rezept-sheets', currentSite, query],
    queryFn: () => getRezeptSheetList(currentSite, query),
    enabled: !!currentSite,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError, refetch, error };
};
